import type { AppLinkId } from '@atlassian/jira-servicedesk-knowledge-services/src/types';

export const FETCH_LINKED_SPACE_SUCCESS =
	'state.actions.fetch-linked-spaces-success.FETCH_LINKED_SPACE_SUCCESS';

export type FetchLinkedSpacesSuccessPayload = {
	spaces: {
		name: string;
		key: string;
		appLinkId: AppLinkId;
	}[];
};

export type FetchLinkedSpacesSuccessAction = {
	type: typeof FETCH_LINKED_SPACE_SUCCESS;
	payload: FetchLinkedSpacesSuccessPayload;
};

export const fetchLinkedSpacesSuccess = (
	payload: FetchLinkedSpacesSuccessPayload,
): FetchLinkedSpacesSuccessAction => ({
	type: FETCH_LINKED_SPACE_SUCCESS,
	payload,
});
